import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Input from '@zg-rentals/multibrand-ui/lib/Input';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import FaqComponent from '@common/components/FaqComponent';
import SpinnerContainer from '@common/components/SpinnerContainer';
import FaqConstants from '@rental-manager/constants/FaqConstants';
import { validateAllInputs } from '../validation';

type Props = {
  tenantFirstName: string;
  tenantLastName: string;
  tenantEmail: string;
  editMode: boolean;
  onSubmit: (...args: any) => void;
  currentTenantEmail: string;
  landlordEmail: string;
};

type State = {
  tenantFirstName: { value: string; error: string };
  tenantLastName: { value: string; error: string };
  tenantEmail: { value: string; error: string };
  isLoading: boolean;
};

class NewTenantInfo extends React.Component<Props, State> {
  static defaultProps = {
    tenantFirstName: '',
    tenantLastName: '',
    tenantEmail: '',
    editMode: false,
    onSubmit: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      tenantFirstName: {
        value: props.tenantFirstName,
        error: '',
      },
      tenantLastName: {
        value: props.tenantLastName,
        error: '',
      },
      tenantEmail: {
        value: props.tenantEmail,
        error: '',
      },
      isLoading: false,
    };
  }

  onInputChange = (e): void => {
    const key = e.target.dataset.statekey;
    const value = e.target.value;
    // @ts-expect-error  will  be addressed in RJS upgrade
    this.setState({
      [key]: {
        value,
        error: '',
      },
    });
  };

  toggleIsLoading = (state = !this.state.isLoading): void => {
    this.setState({ isLoading: state });
  };

  handleSubmit = () => {
    if (!validateAllInputs(this)) {
      return false;
    }

    this.props.onSubmit({
      tenantFirstName: this.state.tenantFirstName.value.trim(),
      tenantLastName: this.state.tenantLastName.value.trim(),
      tenantEmail: this.state.tenantEmail.value.trim(),
    });
  };

  render(): React.ReactNode {
    const { isLoading } = this.state;

    return (
      <>
        {isLoading && <SpinnerContainer />}
        <Row>
          <Col>
            <Text type="h3">Who is your new primary tenant?</Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              data-statekey="tenantFirstName"
              className="fs-exclude"
              label="First name"
              value={this.state.tenantFirstName.value}
              error={this.state.tenantFirstName.error}
              onChange={this.onInputChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              data-statekey="tenantLastName"
              className="fs-exclude"
              label="Last name"
              value={this.state.tenantLastName.value}
              error={this.state.tenantLastName.error}
              onChange={this.onInputChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              data-statekey="tenantEmail"
              className="fs-exclude"
              label="Email address"
              value={this.state.tenantEmail.value}
              error={this.state.tenantEmail.error}
              onChange={this.onInputChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FaqComponent.Landlord faqs={FaqConstants.ONBOARDING_V2.INVITE_TENANT_PAGE} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button type="primary" onClick={this.handleSubmit} full>
              Continue
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default NewTenantInfo;
